export default "__VITE_ASSET__Bgmzx30u__"